/**
 * Zelium AI — Frontend Configuration
 * ====================================
 * Centralises all environment-driven configuration for the frontend.
 * All values come from Vite's import.meta.env (VITE_* prefixed variables).
 *
 * @see frontend/.env for local values
 * @see frontend/.env.example for required variables
 */

const assetsBaseUrl =
  import.meta.env.VITE_ASSETS_BASE_URL?.replace(/\/$/, '') ??
  'https://zeliumstorageprod.blob.core.windows.net/assets';

/**
 * Support contact address.
 */
export const SUPPORT_EMAIL =
  import.meta.env.VITE_SUPPORT_EMAIL ?? 'team@zelium.app';

/**
 * Scoring algorithm version displayed in the UI.
 * Set VITE_ALGO_VERSION in your .env to override.
 */
export const ALGO_VERSION: string =
  import.meta.env.VITE_ALGO_VERSION ?? '0.1.30';

/**
 * CDN / blob storage asset URLs.
 * Use these instead of hardcoding blob URLs in components.
 */
export const ASSETS = {
  logoSvg: `${assetsBaseUrl}/zelium-logo.svg`,
  logo512: `${assetsBaseUrl}/zelium-logo-512.png`,
  logo1024: `${assetsBaseUrl}/zelium-logo-1024.png`,
  embedVideoPoster: `${assetsBaseUrl}/enable-zelium-app-embed-final.png`,
  embedVideoMp4: `${assetsBaseUrl}/enable-zelium-app-embed-final.mp4`,
} as const;
